import { render } from "./MatrixSelect.vue?vue&type=template&id=73a88470&scoped=true"
import script from "./MatrixSelect.vue?vue&type=script&lang=js"
export * from "./MatrixSelect.vue?vue&type=script&lang=js"

import "./MatrixSelect.vue?vue&type=style&index=0&id=73a88470&lang=less&scoped=true"

import exportComponent from "/builds/maizhensheng/app-commonapply-v6/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73a88470"]])

export default __exports__